import React from 'react';
import { cn } from '../../lib/utils';

const statusConfig = {
  initiated: { bg: 'bg-slate-500/10', text: 'text-slate-400', border: 'border-slate-500/20', label: 'Initiated' },
  ringing: { bg: 'bg-amber-500/10', text: 'text-amber-500', border: 'border-amber-500/20', label: 'Ringing' },
  'in-progress': { bg: 'bg-blue-500/10', text: 'text-blue-500', border: 'border-blue-500/20', label: 'In Progress' },
  completed: { bg: 'bg-emerald-500/10', text: 'text-emerald-500', border: 'border-emerald-500/20', label: 'Completed' },
  failed: { bg: 'bg-rose-500/10', text: 'text-rose-500', border: 'border-rose-500/20', label: 'Failed' },
  busy: { bg: 'bg-orange-500/10', text: 'text-orange-500', border: 'border-orange-500/20', label: 'Busy' },
  noanswer: { bg: 'bg-purple-500/10', text: 'text-purple-500', border: 'border-purple-500/20', label: 'No Answer' },
};

export function StatusBadge({ status, className }) {
  const config = statusConfig[status] || statusConfig.initiated;
  
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border',
        config.bg,
        config.text,
        config.border,
        className
      )}
    >
      {status === 'ringing' || status === 'in-progress' ? (
        <span className="relative flex h-2 w-2 mr-1.5">
          <span className={cn('animate-ping absolute inline-flex h-full w-full rounded-full opacity-75', config.text.replace('text-', 'bg-'))} />
          <span className={cn('relative inline-flex rounded-full h-2 w-2', config.text.replace('text-', 'bg-'))} />
        </span>
      ) : null}
      {config.label}
    </span>
  );
}
